import axios from "axios";
import {
    TRANSPORT_BODY_TYPES,
    TRANSPORT_BODY_TYPES_ADDITIONALS,
    VARIANT_TYPES,
    TRANSPORT_LOADING_TYPES_ADDITIONALS,
    ADR,
    UTILS,
    PATRIAL_LOAD,
    CARGO_DESIGNATIONS,
    LOADING_TYPES,
    UNLOADING_TYPES,
    PACKAGES,
    TIME_PERIOD,
} from "../../endpointsConst";

const FreightsDropdowns = {};

FreightsDropdowns.getDesginations = (lang) =>
    axios.get(UTILS + CARGO_DESIGNATIONS + `?lang=${lang}`);

FreightsDropdowns.getPackages = (lang) => axios.get(UTILS + PACKAGES + `?lang=${lang}`);

FreightsDropdowns.getBodyTypes = (lang) =>
    axios.get(UTILS + TRANSPORT_BODY_TYPES + `?lang=${lang}`);

FreightsDropdowns.getBodyTypesAdditional = (lang) =>
    axios.get(UTILS + TRANSPORT_BODY_TYPES_ADDITIONALS + `?lang=${lang}`);

FreightsDropdowns.getVariantLoadingTypes = (lang) =>
    axios.get(UTILS + VARIANT_TYPES + `?lang=${lang}`);

FreightsDropdowns.getLoadingTypes = (lang) =>
    axios.get(UTILS + LOADING_TYPES + `?lang=${lang}`);

FreightsDropdowns.getUnloadingTypes = (lang) =>
    axios.get(UTILS + UNLOADING_TYPES + `?lang=${lang}`);

FreightsDropdowns.getLoadingTypesAdditional = (lang) =>
    axios.get(UTILS + TRANSPORT_LOADING_TYPES_ADDITIONALS + `?lang=${lang}`);

FreightsDropdowns.getAdr = (lang) => axios.get(UTILS + ADR + `?lang=${lang}`);

FreightsDropdowns.getPatrialLoad = (lang) =>
    axios.get(UTILS + PATRIAL_LOAD + `?lang=${lang}`);

FreightsDropdowns.getTimePeriod = (lang) =>
    axios.get(UTILS + TIME_PERIOD + `?lang=${lang}`);

export { FreightsDropdowns };
